export const tableHeaders = ['Listing ID', 'URL', 'Address']
